import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=20355524&"
import script from "./CheckoutPage.vue?vue&type=script&lang=ts&"
export * from "./CheckoutPage.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports